import {configureStore} from '@reduxjs/toolkit';
import complaintReducer from './ComplaintSlice/ComplaintSlice';
import newReducer from './NewsSlice/NewsSlice';
import downloadReducer from './DownloadSlice';
import branchSlice from './Branches'
export const store = configureStore({
    reducer:{
        complaint : complaintReducer,
        news : newReducer,
        download : downloadReducer,
        branches:branchSlice
    },
    devTools:false
})